module.exports = [
  'SalonService', 'RESTService', (SalonService, RESTService) ->
    (id) ->
      RESTService.service('reviews', SalonService.one(id))
]
